import { loadStripe } from '@stripe/stripe-js'
import type { Visitor } from 'api/dto/visitor'

import axios from 'config/axios'
import { environment } from 'config/environment'

const stripePromise = loadStripe(import.meta.env.VITE_LOAD_STRIPE)

export async function redirectToCheckout(tradeshowId: string, visitor: Visitor, email: string) {
  const stripe = await stripePromise
  if (!stripe) {
    return
  }

  const { data: url } = await axios.post(`${environment.restApi.resourceUrl.tradeshows}/${tradeshowId}/checkout`, {
    visitor,
    email,
  })

  window.location.href = url
}
